import './Work.css'

const projects = [
    {
        title: 'UntanglingWeb3',
        desc: 'Podcasts and news from the UntanglingWeb3 group. A dynamic React site fed by an API, with a user-friendly interface.',
        tags: 'React · API',
        image: './images/projects/untanglingWeb3.png',
        link: 'https://untanglingweb3.com/'
    },
    {
        title: 'MB Consulting',
        desc: 'Official site for a consultancy giving technical and professional advice to companies in the food sector.',
        tags: 'Vite · React',
        image: './images/projects/mbconsulting.png',
        link: 'https://www.mbconsultingz.com.ar'
    },
    {
        title: 'María Eugenia Russo',
        desc: 'Site for a laboratory and food-industry quality consultant, designed as a real business tool: fully responsive, with a direct contact channel for clients.',
        tags: 'React · Responsive',
        image: './images/projects/maria-eugenia-russo.jpg',
        link: 'https://www.mariaeugeniarusso.com/'
    },
    {
        title: 'Rick & Morty',
        desc: 'A teaching exercise for my students: consuming APIs, managing data and working with libraries and frameworks.',
        tags: 'React · API',
        image: './images/projects/rick&morty.png',
        link: 'https://rick-and-morty-react-proyect.netlify.app/'
    },
    {
        title: 'Gifos',
        desc: 'One of my favorites: a retro-styled app to create, browse, save and download your own gifs.',
        tags: 'HTML · CSS · JavaScript · API',
        image: './images/projects/gifos.png',
        link: 'https://gifos-proyect.netlify.app/'
    },
    {
        title: 'Somos Noma',
        desc: 'Landing for a project that unites digital nomad women in Latin America, built in React with animations made from scratch.',
        tags: 'React · Animation',
        image: './images/projects/noma.png',
        link: 'https://somos-noma-landing-demo.netlify.app/'
    }
];

const tilts = [-2, 1.5, -1, 1, -1.5, 2];

export default function Work() {
    return (
        <section id='work' className='container work'>
            <div className='work-head' data-reveal>
                <p className='kicker'>§ 03 — Selected Work</p>
                <h2 className='section-title'>Postcards from <em>past projects</em></h2>
            </div>
            <div className='work-grid'>
                {projects.map((project, i) => (
                    <a key={project.title} href={project.link} target='_blank' rel='noreferrer' className='work-link' data-reveal>
                        <article className='postcard' style={{ '--tilt': tilts[i % tilts.length] + 'deg' }}>
                            <div className='postcard-photo'>
                                <img src={project.image} alt={'Screenshot of ' + project.title} loading='lazy'/>
                            </div>
                            <div className='postcard-body'>
                                <div>
                                    <h3>{project.title}</h3>
                                    <p>{project.desc}</p>
                                </div>
                                <span className='postcard-no'>Nº {String(i + 1).padStart(2, '0')}</span>
                            </div>
                            <div className='postcard-tags'>{project.tags}</div>
                        </article>
                    </a>
                ))}
            </div>
        </section>
    )
}
